import { Outlet } from 'react-router-dom';
import { VendorsProvider } from 'modules/vendor';

const VendorWrapper = () => {
    return (
        <VendorsProvider>
            <Outlet />
        </VendorsProvider>
    );
};

export default VendorWrapper;
